<template>
  <div>
    <ConfirmationDialog2 ref="confirmationDialog" />
    <slot :submit="ingest" :loading="loading" />
    <ExecutionResultsDialog title="Ingestion" ref="executionResultsDialog">
      <template #next="{ ReingestionId }">
        <PrimaryBtn icon="event_note" :to="{ name: 'allimports', query: { search: ReingestionId } }">View ingestion summary</PrimaryBtn>
        <PrimaryBtn icon="pending_actions" :to="{ name: 'reviewingestionresults', params: { executionId: ReingestionId }}">Review ingestion</PrimaryBtn>
      </template>
      <template #actions="{ ReingestionId }">
        <template v-if="ReingestionId">
          <PrimaryBtn icon="event_note" :to="{ name: 'allimports', query: { search: ReingestionId } }">View ingestion summary</PrimaryBtn>
          <PrimaryBtn icon="pending_actions" :to="{ name: 'reviewingestionresults', params: { executionId: ReingestionId }}">Review ingestion</PrimaryBtn>
        </template>
      </template>
    </ExecutionResultsDialog>
  </div>
</template>

<script>
  import { reingestConfirmParams } from '@/helpers/datasets/ingestions'
  import { createNamespacedHelpers } from 'vuex'
  const reviewIngestionResults = createNamespacedHelpers('reviewingestionresults')
  const app = createNamespacedHelpers('app')

  export default {
    data: () => ({
      loading: false,
      attempted: {
        tryAgain: false,
        resubmitSavedData: false,
      },
    }),
    computed: {
      ...reviewIngestionResults.mapState(['getData']),
    },
    watch: {
      loading: {
        deep: true,
        handler(val) {
          this.$emit('loading', val)
        },
      },
    },
    methods: {
      ...reviewIngestionResults.mapActions(['resubmitData']),
      ...app.mapActions(['refreshData']),
      resubmitSavedData(fileId) {
        this.attempted.resubmitSavedData = true
        this.$refs.executionResultsDialog.clearLogs()
        this.ingest(true, {
          fileId,
          resubmitData: null,
          isAlreadySaved: true,
        })
      },
      async ingest(fileId, force = false, paramsOverride = {}) {
        this.loading = true
        try {
          let confirmed = await this.$refs.confirmationDialog.confirm(reingestConfirmParams, force)
          if (!confirmed) return

          const params = this.getData()
          let executionResults = await this.resubmitData({
            fileId,
            resubmitData: params,
            ...paramsOverride,
          })

          if (!executionResults.IsError) {
            this.$emit('submit:success')
            this.refreshData({ monitoringFeatures: true })
          }

          this.$refs.executionResultsDialog.show(executionResults)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>